import * as React from 'react'

import AudioPlayerSmallContainer from '../audio/audioPlayerSmall/audioPlayerSmallContainer'
import EnhancedLazyLoad from '../enhancedLazyLoad'
import ImagePlaceholder from '../imagePlaceholder'
import TrendingSash from '../trendingSash'

import * as styles from './audioPreviewer.module.css'

const AudioPreview = ({
  imageUrl,
  audioUrl,
  url,
  isTrending,
  name,
  onClick,
  lazyLoad = false
}: {
  imageUrl: string | undefined
  audioUrl: string
  url: string
  isTrending: boolean
  name: string
  onClick?: () => void
  lazyLoad?: boolean
}) => {
  return (
    <div>
      <div className={styles.miniAudioPlayerContainer}>
        <AudioPlayerSmallContainer src={audioUrl} />
      </div>
      <a
        className={styles.thumbnail}
        href={url}
        onClick={onClick}
        aria-label={name}
      >
        {isTrending && <TrendingSash />}
        <EnhancedLazyLoad
          disabled={!lazyLoad}
          placeholder={<ImagePlaceholder />}
        >
          <img
            alt=""
            role="presentation"
            src={imageUrl}
            title={name}
            width="80"
            height="80"
          />
        </EnhancedLazyLoad>
      </a>
    </div>
  )
}

export default AudioPreview
